import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].GET_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/staff_payments/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].GET_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/staff_payments/:staffPaymentId/',
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/staff_payments/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].PUT_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/staff_payments/:staffPaymentId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/staff_payments/:staffPaymentId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENTS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_STAFF_PAYMENT]: {
		url: '/company/:companyId/order_generators/field_works/:generatorId/staff_payments/:staffPaymentId/',
		requestOptions: {
			method: 'DELETE',
		},
	},

}